import { Modal, Button } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const ProfileNotVerifiedPopup = ({ status }) => {
    const [modal, setModal] = useState();
    const [warning, setWarning] = useState();
    const businessInfoDetails = useSelector(state => state.BusinessInfoReducer?.businessInfo);
    const warningData = businessInfoDetails?.warning;
    const adminStatus = useSelector(state => state.Dashboard?.adminVerificationStatus);
    const handleCancel = () => {
        setModal(false);
    };
    useEffect(() => {
        if (warningData) {
            setWarning(warningData);
        }
    }, [warningData]);
    const flag = useRef(false);

    useEffect(() => {
        if (flag.current) {
            setModal(prev => !prev);
        } else {
            flag.current = true;
        }
    }, [status]);

    return (
        <Modal
            className="sm_modal work_modal center_modal btn_removal"
            open={modal}
            onCancel={handleCancel}
            footer={[
                <div className='text-center'>
                    <Button key="submit" type="primary" className="short wide" onClick={handleCancel}>
                        Ok
                    </Button>
                </div>
            ]}
        >   <h2 className="text_lg text_red">{warning?.title}</h2>
            <p className='md' style={{ lineHeight: '1.5' }}>{warning?.description}</p>
        </Modal>
    );
};

export default ProfileNotVerifiedPopup;
